import dayjs from 'dayjs';
const random = {
    /**
     * @param {poen} peon 需要生成颜色的数组
     * @param {*} busDeptName table row-style 的对应条件
     */
    getHsl: function (peon, busDeptName) {
        const HSL = [];
        for (let i = 0; i < peon.length; i++) {
            const objt = {};
            objt[busDeptName] = peon[i][busDeptName];
            var ret = '';
            // eslint-disable-next-line
            if (i % 2 == 0) {
                ret = '#e21918';
            } else {
                ret = '#919100';
            }
            objt.color = ret;
            HSL.push(objt);
        }
        return HSL;
    },
    /**
     * @function 数组对象按某个参数分组
     * @targetArray 目标数组
     * @gist 参数
     * @user
     */
    gistClassify: function (targetArray, gist) {
        const obj = {};
        const outputArray = [];
        for (let i = 0; i < targetArray.length; i++) {
            const target = targetArray[i];
            if (!obj[target[gist]]) {
                outputArray.push({
                    [gist]: target[gist],
                    data: [target]
                });
                obj[target[gist]] = target;
            } else {
                for (let j = 0; j < outputArray.length; j++) {
                    const targetend = outputArray[j];
                    if (targetend[gist] === target[gist]) {
                        targetend.data.push(target);
                    }
                }
            }
        }
        return outputArray;
    },
    /**
     * @function 数组对象去重
     * @paramsArray 目标数组
     * @deStr 去重依据
     */
    deWeight: function (paramsArray, deStr) {
        const obj = {};
        const deWeightArray = paramsArray.reduce((item, next) => {
            // eslint-disable-next-line
            obj[next[deStr]] ? '' : obj[next[deStr]] = true && item.push(next)
            return item;
        }, []);
        return deWeightArray;
    },
    /**
     * @function dayjs处理时间
     * @param {data} 时间
     * @param {pattern} 时间格式
     */
    getNowFormatDate: function (data, pattern) {
        // 格式化时间和拿到当前星期几
        const dataTime = data || new Date();
        return [
            dayjs(dataTime).format(pattern),
            '星期' + '日一二三四五六'.charAt(new Date().getDay())
        ];
    },
    /**
     * @function 循环请求函数
     * @param {*} that vue
     * @param {*} fn 循环函数
     * @param {*} timeInterval 间隔时间
     * @param {*} timeName name
     */
    refreshData: function(that, fn, timeInterval, timeName) {
        that[fn]();
        that[timeName] = window.setTimeout(() => {
            this.refreshData(that, fn, timeInterval, timeName);
        }, timeInterval);
    },
    /**
     * @desc 函数防抖
     * @param fn 函数
     * @param delay 延迟执行毫秒数
     */
    debounce: function(fn, delay) {
        let timeout = null;
        return function() {
            const args = arguments;
            if (timeout) window.clearTimeout(timeout);
            timeout = setTimeout(() => {
                fn.apply(this, args);
            }, delay);
        };
    },
    /**
     * @desc 根元素
     * @param fn 函数
     * @param screen 屏幕尺寸
     * @param scale 比例（rem,px)
     */
    setRem: function(screen, scale) {
        var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
        return (oWidth / screen) * scale + 'px';
    },
    /**
     * @desc 随机数组
     * @param fn 函数
     * @param length 随机数组长度
     * @param total 随机数组总和
     * @param float 允许键值波动范围,浮点数,0-1之间,数值越大波动越不稳定
     */
    randomArray: function(length, total, float = 0.1) {
        const randomList = [];
        if (!length || !total) {
            return randomList;
        }
        const average = total / length;
        let poor = 0;
        for (let i = 0; i < length - 1; i++) {
            const randomNum = Math.round(Math.random() * float * (average - poor));
            Math.random() >= 0.5 ? poor = 0 - randomNum : poor = randomNum;
            randomList[i] = Math.round(average + poor);
        }
        const randomTotal = randomList.reduce((prev, cur) => {
            return prev + cur;
        });
        randomList[length - 1] = total - randomTotal;
        return randomList;
    }
};

export default random;
